import { useDispatch } from "react-redux";
import { Card } from "antd";
import { addParkingbay } from "../../redux/actions/parkingbay";
import CascadingDropdown from "../CascadingDropdown"

const AddParkingBay = () => {
  const dispatch = useDispatch()
  
  function addParkingBay(payload) {
    dispatch(addParkingbay(payload));
  }

  return (
    <Card 
      title="Add New Master Location" 
      bordered
      style={{ border: "2px solid rgb(0, 168, 204)"}}
      styles={{
        header: { borderBottom: "2px solid rgb(0, 168, 204)", fontSize: "2rem", textAlign: "center", color: "rgb(0, 168, 204)"},
      }}
      >
      <CascadingDropdown addParkingbay={(query) => addParkingBay(query)}/>
    </Card>
  );
};

export default AddParkingBay;
